import { EN } from './EN';
import { RU } from './RU';

export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'ru'];

export const TRANSLATIONS = {
  en: EN,
  ru: RU,
};

let activeLanguage = DEFAULT_LANGUAGE;

export function normalizeLanguage(language) {
  const normalized = String(language || '')
    .trim()
    .toLowerCase()
    .replace('_', '-')
    .split('-')[0];

  return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : '';
}

export function getTranslation(language) {
  return TRANSLATIONS[normalizeLanguage(language) || DEFAULT_LANGUAGE] || EN;
}

export function getActiveLanguage() {
  return activeLanguage;
}

export function setActiveLanguage(language) {
  activeLanguage = normalizeLanguage(language) || DEFAULT_LANGUAGE;
  return activeLanguage;
}
